import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

/**
 * Breadcrumbs Component
 * Usage: <Breadcrumbs items={[{label: 'Shop', href: '/shop'}, {label: 'Category', href: '/category/x'}]} />
 */
const Breadcrumbs = ({ items = [] }) => {
  if (!items || items.length === 0) return null;

  return (
    <nav 
      aria-label="Breadcrumb" 
      className="py-3"
      data-testid="breadcrumbs"
    >
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {/* Home Link */}
        <li className="flex items-center">
          <Link 
            to="/" 
            className="flex items-center gap-1 text-[var(--muted)] hover:text-[var(--brand)] transition-colors"
            data-testid="breadcrumb-home"
          >
            <Home className="h-4 w-4" />
            <span>Home</span>
          </Link>
        </li>

        {/* Breadcrumb Items */}
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li key={`crumb-${item.label}-${index}`} className="flex items-center">
              <ChevronRight className="h-4 w-4 mx-1 text-[var(--border)]" />
              {isLast ? (
                <span 
                  className="font-medium text-[var(--text)]"
                  aria-current="page"
                  data-testid={`breadcrumb-${index}`}
                >
                  {item.label}
                </span>
              ) : (
                <Link 
                  to={item.href}
                  className="text-[var(--muted)] hover:text-[var(--brand)] transition-colors"
                  data-testid={`breadcrumb-${index}`}
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
